import { Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root',
})
export class CornerRightDownIconService {

    render() {
        return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.29289 14.2929C9.68342 13.9024 10.3166 13.9024 10.7071 14.2929L15 18.5858L19.2929 14.2929C19.6834 13.9024 20.3166 13.9024 20.7071 14.2929C21.0976 14.6834 21.0976 15.3166 20.7071 15.7071L15.7071 20.7071C15.3166 21.0976 14.6834 21.0976 14.2929 20.7071L9.29289 15.7071C8.90237 15.3166 8.90237 14.6834 9.29289 14.2929Z" fill="black"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3 3.44772 3.44772 3 4 3H11C12.3261 3 13.5979 3.52678 14.5355 4.46447C15.4732 5.40215 16 6.67392 16 8V20C16 20.5523 15.5523 21 15 21C14.4477 21 14 20.5523 14 20V8C14 7.20435 13.6839 6.44129 13.1213 5.87868C12.5587 5.31607 11.7956 5 11 5H4C3.44772 5 3 4.55228 3 4Z" fill="black"/>
        </svg>          
        `;
    }
}
